import React from 'react'
import QueueAnim from "rc-queue-anim";
import Texty from 'rc-texty';
import 'rc-texty/assets/index.css';
import { OverPack } from "rc-scroll-anim";
import { getEnter } from '@/utils'
import "./index.less";
const ReportList = (props) => {
	const { reportList, className } = props || {};
  return (
		<div className={`report-list-box ${className}`}>
			{
				reportList.map((item, index) => (
					<OverPack key={`queue-${index}`} style={{ minHeight: 90 }} always={true} playScale={[0.2, 0.8]}>
						<QueueAnim
							interval={120}
							leaveReverse
							type="bottom"
							component={"div"}
						>
							<div className="report-li" key={`report-li-${index}`} onClick={item.click}>
								<div className="report-li-left">
									<img src={item.img} alt="" className="report-li-img" />
									{
										item.type && (
											<div className="report-li-type" style={{ background: item.typeBg }}>
												{item.type}
												{/* <Texty className="report-li-content" type="swing-rotate" mode="smooth">
													{item.type}
												</Texty> */}
											</div>
										)
									}
								</div>
								<div className="report-li-right">
									<div className="report-li-title">{item.title}</div>
									{/* <Texty enter={getEnter} leave={getEnter} className="report-li-title">
										{item.title}
									</Texty> */}
									{/* <Texty type="bottom" mode="sync" className="report-li-content">
										{item.content}
									</Texty> */}
									<div className="report-li-content">{item.content}</div>
								</div>
							</div>
						</QueueAnim>
					</OverPack>
				))
			}
		</div>
  )
}

export default ReportList;
